/**
 A source of small random integers based on window.crypto.getRandomValues.
 It also avoids modulo bias.
 */
export class SecureRandomSource {
    constructor() {
        this.randBytes = new Uint8Array(32);
        this.nextByteIndex = this.randBytes.length + 1;  //force immediate reseed
    }

    nextByte(n) {
        if (this.nextByteIndex >= this.randBytes.length) {
            window.crypto.getRandomValues(this.randBytes);
            this.nextByteIndex = 0;
        }

        const b = this.randBytes[this.nextByteIndex];
        this.nextByteIndex++;
        return b;
    };

    /**
     * Return a small random integer >= 0 and < n where
     * n is 256 or less.
     */
    nextSmallInt(n) {
        if (!(n > 0 && n <= 256))
            throw new Error("SecureRandomSource.nextInt: n out of range");

        //https://zuttobenkyou.wordpress.com/2012/10/18/generating-random-numbers-without-modulo-bias/

        var r, i;
        var randmax = 255;

        var limit = randmax - ((randmax+1) % n);

        i = 0;
        while (true) {
            r = this.nextByte();
            if (r <= limit)
                return r % n;

            i++;
            if (i > 1000)
                throw new Error("Bad random source!");
        }
    };

    shuffleString(s) {
        if (s.length > 256)
            throw new Error("String too long to shuffle");

        //My approach here is to assign each character a distinct random number and sort ascending.
        let ar = new Array(s.length);
        let i, r, c;
        for (i = 0; i < s.length; i++) {
            c = s.charAt(i);
            r = this.nextByte();
            ar[i] = [c, r];
        }

        const sortCmp = function(a, b) {
            return a[1] - b[1];
        };

        ar.sort(sortCmp);

        //Reassemble string
        s = '';
        for (i = 0; i < ar.length; i++)
            s += ar[i][0];

        return s;
    };

    randString(alphabet, n) {
        let s = '';
        let j;
        while (s.length < n) {
            j = this.nextSmallInt(alphabet.length);
            s += alphabet.charAt(j);
        }

        return s;
    };

}
